"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _Collapsible2 = _interopRequireDefault(require("./Collapsible.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Collapsible = /*#__PURE__*/function (_React$PureComponent) {
  function Collapsible(props) {
    var _this;
    _classCallCheck(this, Collapsible);
    _this = _callSuper(this, Collapsible, [props]);
    _defineProperty(_this, "closeCollapsible", function () {
      _this.setState({
        height: _this.contentWrapperRef.current.offsetHeight,
        transition: "height ".concat(_this.props.transitionTime, "ms ").concat(_this.props.easing),
        overflow: 'hidden',
        shouldSwitchAutoOnNextCycle: true
      });
    });
    _defineProperty(_this, "openCollapsible", function () {
      _this.setState({
        shouldOpenOnNextCycle: true
      });
    });
    _defineProperty(_this, "continueOpenCollapsible", function () {
      _this.setState({
        height: _this.contentWrapperRef.current.offsetHeight,
        transition: "height ".concat(_this.props.transitionTime, "ms ").concat(_this.props.easing),
        isClosed: false,
        overflow: 'hidden',
        shouldOpenOnNextCycle: false
      });
    });
    _defineProperty(_this, "handleClick", function (event) {
      event.preventDefault();
      if (_this.props.disabledCollapse) return;
      if (_this.state.isClosed === true) {
        _this.openCollapsible();
        if (_this.props.onOpen) _this.props.onOpen();
      } else {
        _this.closeCollapsible();
        if (_this.props.onClose) _this.props.onClose();
      }
    });
    _defineProperty(_this, "handleTransitionEnd", function () {
      if (!_this.state.isClosed) {
        _this.setState({
          height: 'auto',
          overflow: 'visible'
        });
        if (_this.props.onOpen) _this.props.onOpen();
      } else if (_this.props.onClose) _this.props.onClose();
    });
    _defineProperty(_this, "contentWrapperRef", null);
    _this.contentWrapperRef = /*#__PURE__*/_react["default"].createRef();
    if (props.isOpen) {
      _this.state = {
        isClosed: false,
        shouldSwitchAutoOnNextCycle: false,
        height: 'auto',
        transition: 'none',
        overflow: 'visible'
      };
    } else {
      _this.state = {
        isClosed: true,
        shouldSwitchAutoOnNextCycle: false,
        height: 0,
        transition: "height ".concat(props.transitionTime, "ms ").concat(props.easing),
        overflow: 'hidden'
      };
    }
    return _this;
  }
  _inherits(Collapsible, _React$PureComponent);
  return _createClass(Collapsible, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;
      if (this.state.shouldOpenOnNextCycle) {
        this.continueOpenCollapsible();
      }
      if (prevState.height === 'auto' && this.state.shouldSwitchAutoOnNextCycle === true) {
        setTimeout(function () {
          _this2.setState({
            height: 0,
            isClosed: true,
            shouldSwitchAutoOnNextCycle: false,
            overflow: 'hidden'
          });
        }, 50);
      }
      if (prevProps.isOpen !== this.props.isOpen) {
        if (this.props.isOpen === true) {
          this.openCollapsible();
          if (this.props.onOpen) this.props.onOpen();
        } else {
          this.closeCollapsible();
          this.props.onClose();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        trigger = _this$props.trigger;
      var contentWrapperStyle = {
        height: this.state.height,
        maxHeight: this.setState.maxHeight,
        transition: this.state.transition,
        overflow: this.state.overflow
      };
      return /*#__PURE__*/_react["default"].createElement(_Collapsible2["default"], {
        className: "".concat(className, " ").concat(this.state.isClosed ? 'collapsed' : 'expanded')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(className, "-trigger"),
        onClick: function onClick(event) {
          _this3.handleClick(event);
        },
        onKeyDown: function onKeyDown(event) {
          _this3.handleClick(event);
        },
        role: "link",
        tabIndex: "0"
      }, trigger), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(className, "-content"),
        style: contentWrapperStyle,
        onTransitionEnd: this.handleTransitionEnd
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "content-wrapper",
        ref: this.contentWrapperRef
      }, children)));
    }
  }]);
}(_react["default"].PureComponent);
Collapsible.defaultProps = {
  className: 'collapsible',
  disabledCollapse: false,
  isOpen: true,
  onClose: undefined,
  onOpen: undefined,
  transitionTime: 400,
  easing: 'ease-in-out'
};
Collapsible.propTypes = {
  /** Text or html to be displayed inside the collapsible element */
  children: _propTypes["default"].node.isRequired,
  /** The CSS class name of the wrapper element. */
  className: _propTypes["default"].string,
  /** The transition animation easing for expanding or collapsing. */
  easing: _propTypes["default"].string,
  /** Flag to indicate if clicking on the trigger should be disabled */
  disabledCollapse: _propTypes["default"].bool,
  /** External prop to indicate if the component should be opened or closed. */
  isOpen: _propTypes["default"].bool,
  /** Action to trigger when closing the collapsible tab */
  onClose: _propTypes["default"].func,
  /** Action to trigger when opening the collapsible tab */
  onOpen: _propTypes["default"].func,
  /** The collapsible section title. Usually a CollabibleTrigger component */
  trigger: _propTypes["default"].node.isRequired,
  /** Time in ms for the expand/collapse transitions to complete */
  transitionTime: _propTypes["default"].number
};
var _default = exports["default"] = (0, _utils.withDeprecationNotice)(Collapsible, 'Collapsible is deprecated. Please use Collapse.jsx');